import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Deprecated from './containers/deprecated/Deprecated'

export default () => (
  <Switch>
    <Route component={Deprecated} />
  </Switch>
)
